import React, { useState, useEffect, useRef, useReducer } from "react";
import { useLocation } from 'react-router-dom';
import { Dropdown, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LogoutPage from './Logout';
import Select from "react-select";
import profile from "../../../images/staff/admin.png";
import price_list from "../../../images/magic_menu/price-list.ico";
import remainder from "../../../images/magic_menu/remainder.ico";
import subscription_calculator from "../../../images/magic_menu/subscription-calculator.ico";
import low_stock from "../../../images/magic_menu/low_stock.ico";
import vendor from "../../../images/magic_menu/vendor.ico";
import swal from "sweetalert2";
import $ from 'jquery';
import Subscription_Calculation from '../../modal/Magic_Menu/Subscription_Calculation/Subscription_Calculation';
import Renewal_Remainder from '../../modal/Magic_Menu/Renewal_Remainder/Renewal_Remainder';
import Vendor_Outstanding from '../../modal/Magic_Menu/Vendor_Outstanding/Vendor_Outstanding';
import Package_Price from '../../modal/Magic_Menu/Package_Price_list/Package_Price_List';
import Low_Stock from '../../modal/Magic_Menu/Low_Stock_Display/Low_Stock_Display';
import Profile from './../../modal/Profile/Edit';
import PromiseCount from '../../modal/Team_Management/Team_Promise/PromiseCount';
import PromiseReason from '../../modal/Team_Management/Team_Promise/PromiseReason';
import NotificationIcon from '../../../images/notify.gif';
import Drawer from '@mui/material/Drawer';
import CouponValidator from '../../modal/Magic_Menu/CouponValidator/CouponValidator';
import GSTCalculator from '../../modal/Magic_Menu/GSTCalculator/GSTCalculator';
import PublicCoupon from '../../modal/Magic_Menu/PublicCoupon/PublicCoupon';

let alreadyCheckedToday = false;
const Header = ({ onNote }) => {
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false); // Modal visibility state
  const [modalType, setModalType] = useState("");
  const [headerFix, setheaderFix] = useState(false);
  const [userName, setUserName] = useState("Loading...");
  const [userImage, setUserImage] = useState("");
  const [email, setemail] = useState("");
  const [staff_id, setstaffid] = useState("");
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const [user, setUser] = useState({});
  const [user_id, setUser_id] = useState(0);
  const [user_type, setUser_type] = useState(0);

  const [branch_option, setBranchOption] = useState([]);
  const [branch, setBranch] = useState(null);
  const [branchDisp, setBranchDisp] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showReason, setShowreason] = useState(false);
  const [data, setdata] = useState({});
  
  const [subsciptions, setsubscriptions] = useState(0);
  const [catering, setcatering] = useState(0);
  const [corporate, setcorporate] = useState(0); 
  const [amount, setamount] = useState(0);

  const fetchpromise = (user_id) => {
    axios.get(`${baseURL}/team_management/check_promises/${user_id}`)
    .then(response => {
        setdata(response.data);
        if(response.data.is_promise == 1){
          setShowModal(true);
        } else {
          setShowModal(false);
        }
    })
    .catch(error => {
        console.log('There was an error fetching the data!', error);
    });
  };

  const fetchreason = (user_id) => {
    axios.get(`${baseURL}/team_management/check_reason/${user_id}`)
    .then(response => {
        setdata(response.data);
        if(response.data.is_reason == 1){
          setShowreason(true);
        } else {
          setShowreason(false);
        }
    })
    .catch(error => {
        console.log('There was an error fetching the data!', error);
    });
  };

  useEffect(() => {
    setTimeout(function () {
      const dropbtn = document.getElementById("droptoggle1");
      if (dropbtn) { // --------------------------------------------- modified
        function toggledrop() {
          return dropbtn.classList.toggle("show");
        }
        dropbtn.addEventListener("click", toggledrop);
      }
    }, 500); 

    window.addEventListener("scroll", () => {
      setheaderFix(window.scrollY > 50);
    });

    // Fetch logged-in user info
    const token = localStorage.getItem("token");
    // console.log(token);
    if (token) {
      axios
        .get(`${baseURL}/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
        //   console.log(res.data);
          setUser(res.data);
          setUserName(res.data.name || "User");
          localStorage.setItem('user_id',(res.data.id));
          setUser_id(res.data.id);
          setUserImage(res.data.img_url);
          setemail(res.data.email);
          setstaffid(res.data.staff_id);
          if(res.data.is_superadmin === 1){
            setUser_type(1);
          } else {
            setUser_type(0);
          }
          setBranch(res.data.branch_id);
          if(res.data.staff_id){
            fetchpromise(res.data.id);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch user info:", err);
          setUserName("User");
          localStorage.removeItem('user_id');
          localStorage.removeItem('user_permissions');
          navigate("/login"); // --------------------------------------------- modified
        });
    } else {
      setUserName("Guest");
      localStorage.removeItem('user_id');
      navigate("/login"); // --------------------------------------------- modified
    }
  }, []);

  const [permissions, setPermissions] = useState({
      view_dashboard: 0,
      branch_man: 0,
      man_branch: 0,
      branch_list: 0,
      branch_add: 0,
      branch_edit: 0,
      branch_view: 0,
      branch_delete: 0,
      branch_add_staff: 0,
      branch_add_area: 0,
      branch_add_dpoint: 0,
      branch_asign_manager: 0,
      man_area: 0,
      area_list: 0,
      area_edit: 0,
      area_delete: 0,
      man_dpoint: 0,
      dpoint_list: 0,
      dpoint_edit: 0,
      dpoint_delete: 0,
      pack_man: 0,
      man_product: 0,
      prod_catego: 0,
      product_category_list: 0,
      product_category_add: 0,
      product_category_edit: 0,
      product_category_delete: 0,
      product: 0,
      products_list: 0,
      products_add: 0,
      products_edit: 0,
      products_view: 0,
      products_delete: 0,
      products_item_quantity: 0,
      item_quans: 0,
      item_quantity_list: 0,
      item_quantity_edit: 0,
      item_quantity_view: 0,
      man_pack: 0,
      package_list: 0,
      package_edit: 0,
      package_delete: 0,
      lead_man: 0,
      man_lead: 0,
      lead_list: 0,
      lead_add: 0,
      lead_edit: 0,
      lead_followup: 0,
      lead_view: 0,
      lead_import: 0,
      lead_export: 0,
      lead_subscribe: 0,
      man_coupon: 0,
      coupon_list: 0,
      coupon_add: 0,
      coupon_edit: 0,
      coupon_view: 0,
      subscri_man: 0,
      subscriber_list: 0,
      subscriber_view: 0,
      subscriber_edit: 0,
      subscriber_filter: 0,
      subscriber_new_subscription: 0,
      subs_man: 0,
      subscription_list: 0,
      subscription_view: 0,
      subscription_edit: 0,
      subscription_export: 0,
      subscription_hold: 0,
      subscription_complaints: 0,
      subscription_renewal: 0,
      pay_man: 0,
      payment_export: 0,
      payment_list: 0,
      prod_man: 0,
      man_items: 0,
      item_catego: 0,
      item_category_list: 0,
      item_category_add: 0,
      item_category_edit: 0,
      item_category_delete: 0,
      item_sub_catego: 0,
      item_sub_category_list: 0,
      item_sub_category_add: 0,
      item_sub_category_edit: 0,
      item_sub_category_delete: 0,
      items: 0,
      items_list: 0,
      items_add: 0,
      items_edit: 0,
      items_view: 0,
      items_delete: 0,
      item_needed_material: 0,
      item_receipe_notes: 0,
      comp_man: 0,
      complaint_list: 0,
      complaint_add: 0,
      complaint_status: 0,
      complaint_view: 0,
      maintenance_man: 0,
      man_vehi: 0,
      vehicle_list: 0,
      vehicle_add: 0,
      vehicle_edit: 0,
      vehicle_view: 0,
      vehicle_delete: 0,
      vehicle_maintannce: 0,
      vehicle_export: 0,
      man_mainten: 0,
      maintenance_list: 0,
      maintenance_edit: 0,
      maintenance_status: 0
  });

  useEffect (() => {
    if(user_id){
      axios.get(`${baseURL}/manageuser/permission/${user_id}`)
        .then(response => {
            setPermissions(response.data);
        })
        .catch(error => {
            console.log('There was an error fetching the data!', error);
        });
    }
  }, [user_id]);

  useEffect (() => {
    if(permissions){
      localStorage.removeItem('user_permissions');
      localStorage.setItem('user_permissions', JSON.stringify(permissions));
    }
  }, [permissions]);

  // get branch dropdown
  useEffect(() => {
      axios.get(`${baseURL}/dropdown/branch`)
        .then(response => {
          const formatted = response.data.data.map(item => ({
              value: item.sno,
              label: 'APF - ' + item.branch_name,
          }));
          setBranchOption(formatted);
          // setBranch(formatted[0]);
        })
        .catch(error => {
              console.log('There was an error fetching the posts!', error);
        });
  }, []);

  useEffect(() => {
      if(branch && branch_option) {
        setBranchDisp(branch_option.find(opt=> opt.value === branch));
      } else if (!branch && branch_option){
        setBranchDisp(branch_option[0]);
      }
  }, [branch, branch_option]);

  useEffect(() => {
      if(branch){
        localStorage.removeItem('branch_id');
        localStorage.setItem('branch_id',(branch));
        
        axios.get(`${baseURL}/get_header_count/${branch}`)
          .then(response => {
            setsubscriptions(response.data.subscription_count);
            setcatering(response.data.catering_count);
            setcorporate(response.data.corporate_count);
            setamount(response.data.amount);
            
          })
          .catch(error => {
            console.error('There was an error fetching the data!', error);
          });
        
      } else {
        localStorage.removeItem('branch_id');
      }
  }, [branch]);

  const toggle_branch_change = (selectedOption) => {
    if(selectedOption != branchDisp) {
      swal.fire({
          html: `
                <div class="text-center mb-2">
                    <i class="fas fa-exclamation-circle fa-3x text-warning"></i>
                </div>
                <div class="alert alert-danger px-2 py-2" role="alert">
                    Confirm Branch Change
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                  
                  <div class="row mb-2 text-center">
                      <label class="text-black font-w300"><b>You're about to switch from <strong class="text-danger">${branchDisp.label}</strong> to <strong class="text-danger">${branch_option.find(opt => opt === selectedOption).label}</strong>. Do you want to proceed?</b></label>
                  </div>
              `,
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
          customClass: {
              title: 'fs-6',
              cancelButton: 'btn btn-sm btn-secondary',
              confirmButton: 'btn btn-sm btn-success',
              htmlContainer: 'text-left'
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
      }).then((result) => {
          if (result.isConfirmed) {
              setBranchDisp(selectedOption); // for Select display
              setBranch(selectedOption.value);   // for storing sno
              if(selectedOption) {
                const postData = { branch_id: selectedOption.value };
                axios.post(`${baseURL}/update_user_branch/${user_id}`, postData)
                    .then(response => {
                      window.location.reload();
                        // toast.success("Lead Created Successfully!");
                    }).catch(error => {
                        console.log(error);
                        // toast.error("Lead Creation Failed");
                    });
              }
          }
      });
    }
  };


  const handleModalToggle_Edit = () => {
		setModalType("EditProfile");  // Set the modal type to "Add"
		setOpen(true);
	};
  
  const handleModalToggle_subscription_calculation = () => {
		setModalType("Subscription_Calculation");
		setOpen(true);
	};

	const handleModalToggle_renewal_remainder = () => {
		setModalType("Renewal_Remainder");
		setOpen(true);
	};

	const handleModalToggle_vendor_outstanding = () => {
		setModalType("Vendor_Outstanding");
		setOpen(true);
	};

	const handleModalToggle_package_price_list = () => {
		setModalType("Package_Price");
		setOpen(true);
	};

	const handleModalToggle_low_stock = () => {
		setModalType("Low_Stock");
		setOpen(true);
	};
	
	const handleModalToggle_gst_calculator = () => {
    setModalType("GST_Caluclator");
    setOpen(true);
  };
 
   const handleModalToggle_coupon_validator = () => {
    setModalType("Coupon_Validator");
    setOpen(true);
  };
 
 
   const handleModalToggle_public_coupon = () => {
    setModalType("Public_Coupon");
    setOpen(true);
  };

  // setInterval(() => {
  //     fetch(`${baseURL}/team_management/calculate_converted_count`)
  //         .then(response => response.json())
  //         // .then(data => console.log('API called every 30 min', data))
  //         .catch(error => console.error('API error:', error));
  // }, 120000); // 30 minutes = 1800000 ms

  useEffect(() => {
      const interval = setInterval(() => {
          fetch(`${baseURL}/team_management/calculate_converted_count`)
              .then(response => response.json())
              .catch(error => console.error('API error:', error));
      }, 1800000); // 2 minutes

      return () => clearInterval(interval); // cleanup
  }, []);


  if (hours >= 16 && minutes >= 0 && !alreadyCheckedToday) {
    if(user_id && staff_id) {
      fetchreason(user_id);
      alreadyCheckedToday = true;
    }
  }
  
  
  
  const [filterOpen, setFilterOpen] = useState(false);
  const onClose = () => {
        setFilterOpen(false);
  };

  
  const [notifications, setNotifications] = useState([]);

  // Icon mapping based on notification_type
  const getIconByType = (type) => {
    switch (type) {
      case 1:
        return 'fa-money-bill-wave'; // Subscription Payment
      case 2:
        return 'fa-boxes-stacked'; // Stock Level Low
      case 3:
        return 'fa-box-open'; // Product Dropped
      default:
        return 'fa-bell'; // Default icon
    }
  };

  // Time formatting utility (e.g., "3 mins ago")
  const getTimeAgo = (datetimeStr) => {
    const now = new Date();
    const datetime = new Date(datetimeStr);
    const diff = Math.floor((now - datetime) / 1000); // in seconds

    if (diff < 60) return `${diff} sec${diff > 1 ? 's' : ''} ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} min${diff > 60 ? 's' : ''} ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hour${diff > 3600 ? 's' : ''} ago`;
    return `${Math.floor(diff / 86400)} day${diff > 86400 ? 's' : ''} ago`;
  };

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(`${baseURL}/all_notification`); // Adjust base URL as needed
      const apiData = res.data.data;

      const formatted = apiData.map((item) => ({
        id: item.sno,
        icon: getIconByType(item.notification_type),
        title: item.title,
        message: item.description,
        time: getTimeAgo(item.datetime),
        read: item.is_read === 1
      }));
      
      setNotifications(formatted);
    } catch (err) {
      console.error('Error fetching notifications:', err);
    }
  };

  // Fetch notifications from API
  useEffect(() => {
    fetchNotifications();
  }, []);


  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
    axios.post(`${baseURL}/clear_notification/${id}`)
        .then(response => {
          fetchNotifications();
        })
        .catch(error => {
              console.log('There was an error read notification', error);
        });
  };

  const clearAll = () => {
      setNotifications([]);

      axios.post(`${baseURL}/clear_all_notification`)
        .then(response => {
          fetchNotifications();
        })
        .catch(error => {
              console.log('There was an error read notification', error);
        });
  };

  // Mark all as read
  const markAllAsRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));

    axios.post(`${baseURL}/read_all_notification`)
        .then(response => {
          fetchNotifications();
        })
        .catch(error => {
              console.log('There was an error read notification', error);
        });
  }

  return (
    <div className={`header ${headerFix ? "is-fixed" : ""}`}>

      <PromiseCount show={showModal} onClose={() => setShowModal(false)} data={data} />
      <PromiseReason show={showReason} onClose={() => setShowreason(false)} data={data} />

      {open && modalType === "Subscription_Calculation" && (
        <Subscription_Calculation show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "Renewal_Remainder" && (
        <Renewal_Remainder show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "Vendor_Outstanding" && (
        <Vendor_Outstanding show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "Package_Price" && (
        <Package_Price show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "Low_Stock" && (
        <Low_Stock show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "EditProfile" && (
          <Profile show={open} onClose={() => setOpen(false)} user={user} setUser={setUser} propToken={localStorage.getItem("token")} />
      )}
     {open && modalType === "Coupon_Validator" && (
        <CouponValidator show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "GST_Caluclator" && (
        <GSTCalculator show={open} onClose={() => setOpen(false)} />
      )}
      {open && modalType === "Public_Coupon" && (
        <PublicCoupon show={open} onClose={() => setOpen(false)} />
      )}
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="container d-block my-0">
            <div className="d-flex align-items-center justify-content-sm-between justify-content-end">
              
              
              <div className="container-fluid d-flex justify-content-evenly">
                <div className="d-flex flex-column text-center py-1 px-2 border border-dark rounded  text-black "  style={{background:'#ebfcebff'}}>
                  <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Active Subscription</span></Tooltip>} >
                    <div className="fs-6">Subscription<span className=" fs-8 text-primary font-w600 ms-1">({new Date().toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).replace(/ /g, '-')})</span></div>
                  </OverlayTrigger>
                  
                  <div className="font-w500 fs-4">{subsciptions}</div>
                  
                </div>
                <div className="d-flex flex-column text-center py-1 px-2 border border-dark rounded  text-black"  style={{background:'#E5FFFB'}}>
                  <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Catering Order</span></Tooltip>} >
                    <div className="fs-6">Catering<span className=" fs-8 text-primary font-w600 ms-1">({new Date().toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).replace(/ /g, '-')})</span></div>
                  </OverlayTrigger>
                  
                  <div  className="font-w500 fs-4">{catering}</div>
                </div>
                <div className="d-flex flex-column text-center py-1 px-2 border border-dark rounded  text-black"  style={{background:'#E5ECFF'}}>
                  <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Corp Order</span></Tooltip>} >
                    <div className="fs-6">Corp<span className=" fs-8 text-primary font-w600 ms-1">({new Date().toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).replace(/ /g, '-')})</span></div>
                  </OverlayTrigger>
                  
                  <div  className="font-w500 fs-4">{corporate}</div>
                </div>
                <div className="d-flex flex-column text-center py-1 px-2 border border-dark rounded  text-black"  style={{background:'#fff1efff'}}>
                  <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Amount</span></Tooltip>} >
                    <div className="fs-6"> Amount<span  className=" fs-8 text-primary font-w600 ms-1">({new Date().toLocaleDateString('en-GB', { month: 'short', year: 'numeric'}).replace(/ /g, '-')})</span></div>
                  </OverlayTrigger>
                  
                  <div  className="font-w500 fs-4">₹{amount}</div>
                </div>

                {user_type === 1 && (
                  <li className="align-content-center me-2">
                    <div className="col-lg-12">
                      <Select placeholder="Select Branch" options={branch_option} value={branchDisp} onChange={toggle_branch_change}/>
                    </div>
                  </li>
                )}

              </div>
              
              {/* {user_type !== 1 && (
                <span className="badge bg-primary fw-bold fs-7 w-md-100 w-lg-300px py-1 text-center">
                  {branchDisp ? branchDisp.label : ''}
                </span>
              )} */}
              
              <ul className="navbar-nav header-right align-content-center">
                <li>
					<div ref={dropdownRef} className="border border-2 border-primary mt-4 me-1" style={{ borderRadius: '7px' }}>
						<Dropdown drop=''>
							<Dropdown.Toggle
								as="a"
								className="i-false cursor-pointer nav-link active dropdown-toggle"
								style={{ padding: '3px' }}
							>
								<svg viewBox="-0.5 0 25 25" width="25px" height={'25px'} fill="none" xmlns="http://www.w3.org/2000/svg">
									<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
									<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path d="M19 3.32001H16C14.8954 3.32001 14 4.21544 14 5.32001V8.32001C14 9.42458 14.8954 10.32 16 10.32H19C20.1046 10.32 21 9.42458 21 8.32001V5.32001C21 4.21544 20.1046 3.32001 19 3.32001Z" stroke="#025d3a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
										<path d="M8 3.32001H5C3.89543 3.32001 3 4.21544 3 5.32001V8.32001C3 9.42458 3.89543 10.32 5 10.32H8C9.10457 10.32 10 9.42458 10 8.32001V5.32001C10 4.21544 9.10457 3.32001 8 3.32001Z" stroke="#025d3a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
										<path d="M19 14.32H16C14.8954 14.32 14 15.2154 14 16.32V19.32C14 20.4246 14.8954 21.32 16 21.32H19C20.1046 21.32 21 20.4246 21 19.32V16.32C21 15.2154 20.1046 14.32 19 14.32Z" stroke="#025d3a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
										<path d="M8 14.32H5C3.89543 14.32 3 15.2154 3 16.32V19.32C3 20.4246 3.89543 21.32 5 21.32H8C9.10457 21.32 10 20.4246 10 19.32V16.32C10 15.2154 9.10457 14.32 8 14.32Z" stroke="#025d3a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
									</g>
								</svg>
							</Dropdown.Toggle>
							<Dropdown.Menu className="" style={{ width: '35%', boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' }}>
								<div className="text-center fs-5 font-w500 text-red border-bottom">Magic Menu's</div>
								<div className="row ">
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_package_price_list}>
										<div className="text-center px-1 py-1">
											<img src={price_list} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Package<br></br> Price List</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2">
										<div className="text-center px-1 py-1">
											<img src={price_list} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Catering Order Remainder</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_renewal_remainder}>
										<div className="text-center px-1 py-1">
											<img src={remainder} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Renewal Remainder</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_subscription_calculation}>
										<div className="text-center px-1 py-1">
											<img src={subscription_calculator} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Subscription Calculator</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_low_stock}>
										<div className="text-center px-1 py-1">
											<img src={low_stock} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Low Stock <br></br>Display</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_vendor_outstanding}>
										<div className="text-center px-1 py-1">
											<img src={vendor} className='w-50px h-50px' alt="price List" />
										</div>
										<div className="text-center text-primary fs-7 font-w600">Vendor Outstanding</div>
									</Link>
									<Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_gst_calculator}>
                    <div className="text-center px-1 py-1">
                      <img src={vendor} className='w-50px h-50px' alt="price List" />
                    </div>
                    <div className="text-center text-primary fs-7 font-w600">GST Calculator</div>
                  </Link>
                      <Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_coupon_validator}>
                    <div className="text-center px-1 py-1">
                      <img src={vendor} className='w-50px h-50px' alt="price List" />
                    </div>
                    <div className="text-center text-primary fs-7 font-w600">Coupon Validator</div>
                  </Link>
                      <Link className="col-4 border-end border-bottom pt-2" onClick={handleModalToggle_public_coupon}>
                    <div className="text-center px-1 py-1">
                      <img src={vendor} className='w-50px h-50px' alt="price List" />
                    </div>
                    <div className="text-center text-primary fs-7 font-w600">Public Coupon</div>
                  </Link>
								</div>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</li>
				
				
				<li>
                  <div ref={dropdownRef} className="border border-2 border-primary mt-4 me-1 position-relative" style={{ borderRadius: '7px' }}>
                    <Link to={"#"} className="i-false cursor-pointer nav-link active" onClick={() => setFilterOpen(true)} style={{padding: '3px'}}>
                      <img src={NotificationIcon} className='w-25px h-25px' alt="price List" />
                    </Link>
                    <span
                      className="position-absolute bottom-75 start-100 translate-middle-x"
                      style={{
                        animation: 'blink 1s infinite',
                        WebkitAnimation: 'blink 1s infinite'
                      }}
                    >
                      <span className="text-white bg-danger rounded-circle py-1 px-1 fs-7 font-w500">{String(notifications.filter(n => !n.read).length).padStart(2, '0')}</span>
                    </span>
                  </div>								
                </li>
				
				<li>
                    <Dropdown className="header-profile2 ">
                      <Dropdown.Toggle as="a" className={`nav-link i-false cursor-pointer py-2`} id="droptoggle1"
  
                      >
                        <div className="header-info2 d-flex align-items-center">
                          <img src={userImage || profile} alt="" />
                          <div className="d-flex align-items-center sidebar-info">
                            {/* <div>
                              <h6 className="font-w500 mb-0 ms-2">Aadhithan M</h6>
                            </div> */}
                            <i className="fas fa-chevron-down"></i>
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu-end w-100">
                        <Link className="dropdown-item ai-icon " onClick={handleModalToggle_Edit}>
                          <i class="fa-solid fa-user fs-5 me-1"></i>
                          <span className="ms-2 fs-7">Profile</span>
                        </Link>
                        <LogoutPage />
                      </Dropdown.Menu>
                    </Dropdown>
                </li>
                
                
              </ul>
            </div>
          </div>
        </nav>
      </div>
      
      <Drawer
      anchor="right"
      open={filterOpen}
      onClose={() => setFilterOpen(false)}
      disableEscapeKeyDown
      BackdropProps={{
          onClick: (e) => e.stopPropagation(),
      }}
      sx={{
          width: 600,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
              width: 500,
              boxSizing: 'border-box',
          },
          '@media (max-width: 375px)': {
              '& .MuiDrawer-paper': {
                  width: 420,
              },
          },
          '@media (max-width: 320px)': {
              '& .MuiDrawer-paper': {
                  width: 300,
              },
          },
      }}
    >
      <div className='modal-header mb-0 px-4 pt-2 pb-0'>
      <h5 className='fs-4'>Notification</h5>
                <div>
                    <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                        <span className='fs-2'>×</span>
                    </Button>
                </div>
            </div>
      <div className='card border-0'>
      <div className='card-body py-0'>
        <div className='row mb-2 py-2'>
          <div className="col-lg-12 mb-4 d-flex align-items-center justify-content-between flex-row">
            <label className="border border-2 border-danger text-danger rounded py-1 px-2" style={{ backgroundColor: '#ffe9e9' }}>
              {String(notifications.filter(n => !n.read).length).padStart(2, '0')} New Messages
            </label>
            <label
              className="border border-2 border-warning text-warning rounded py-1 px-2"
              style={{ backgroundColor: '#fff8e9ff', cursor: 'pointer' }}
              onClick={markAllAsRead}
            >
              Mark All as Read
            </label>
          </div>
        </div>

        <div className="row mb-2">
          {notifications.map((n) => (
            <div
              key={n.id}
              className="col-lg-12 mb-2 d-flex align-items-center justify-content-between gap-2 flex-row border border-gray-600 py-2 rounded"
              style={{
                backgroundColor: n.read ? '#ffffff' : '#f0f0f0' // change color if read
              }}
            >
              <div className="d-flex align-items-center justify-content-start gap-2 flex-row">
                <label className="border-primary border rounded py-2 px-2" style={{ backgroundColor: '#ccfae833' }}>
                  <i className={`fa-solid ${n.icon} text-primary fs-2`}></i>
                </label>
                <div className="d-flex align-items-start justify-content-start gap-0 flex-column">
                  <label className="fs-6 text-danger font-w500">{n.title}</label>
                  <label className="fs-8 text-dark font-w500 text-wrap">{n.message}</label>
                  <span className='bg-info text-white py-1 px-2 rounded'>{n.time}</span>
                </div>
              </div>
              <div>
                <Button variant="" size='sm' onClick={() => removeNotification(n.id)}>
                  <span className='fs-5'>×</span>
                </Button>
              </div>
            </div>
          ))}
        </div>

        {notifications.length > 0 && (
          <div className="d-flex align-items-center justify-content-end gap-1">
            <Button className="me-2 btn-sm" variant="secondary" onClick={clearAll}>
              <span className='font-w400 fs-7'>Clear All</span>
            </Button>
          </div>
        )}
      </div>
      </div>
    </Drawer>
      
      
    </div>
  );
};

export default Header;
